import { render, staticRenderFns } from "./AddnewFam.vue?vue&type=template&id=f8b1c6f6&"
import script from "./AddnewFam.vue?vue&type=script&lang=js&"
export * from "./AddnewFam.vue?vue&type=script&lang=js&"
import style0 from "./AddnewFam.vue?vue&type=style&index=0&id=f8b1c6f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports